import React, { useContext } from 'react';
import { CollapseCard } from '@totalsoft/rocket-ui';
import Assignment from '@mui/icons-material/Assignment';
import PropTypes from 'prop-types';
import FolderCommentsContainer from './FolderCommentsContainer';
import { RightsContext } from 'providers/RightsContext';
import { useTranslation } from 'react-i18next';

export const FolderCommentsCardContainer = ({ documentId, siteId }) => {
  const { riskAssesmentNotesRead } = useContext(RightsContext);
  const { t } = useTranslation();

  return (
    !!riskAssesmentNotesRead && (
      <CollapseCard icon={Assignment} title={t('Folder.RiskComments.Title')} toggleOnHeaderClick>
        <FolderCommentsContainer documentId={documentId} siteId={siteId} />
      </CollapseCard>
    )
  );
};

FolderCommentsCardContainer.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired
};

export default FolderCommentsCardContainer;
